define('bindingHandlers/contentTypeName',['lib/knockout', 'services/contentTypeService'], function (ko, contentTypeService) {
    'use strict';

    /**
     * Binding handler that converts a mime type like application/pdf to a friendly name like PDF.
     * Sample usage:
     *  data-bind = "contentTypeName: mimeType"
     */
    ko.bindingHandlers.contentTypeName = {
        init: function (element, valueAccessor) {
            var mimeType = ko.unwrap(valueAccessor());

            element.innerHTML = contentTypeService.getName(mimeType);
        }
    };
    return ko.bindingHandlers.contentTypeName;
});

